import Fetch from 'jsx/common/util/_fetch';
import { RemoteAccessProfile } from '@mss/mss-component-library';

const update = async (profile: RemoteAccessProfile & { id: string }) => {
  return Fetch.put(`/api/remote-profile/${profile.id}/`, {
    body: JSON.stringify(profile),
  });
};

export default update;
